module.exports = __webpack_public_path__ + "resources/img/solution_game_consulting_m.ba5ec91b6c6e0982483896fec4fbac11.png";